import { css } from "@emotion/react";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, IconButton, useTheme } from "@mui/material";
import { useState } from "react";
import {
  PiCardsFill,
  PiCardsLight,
  PiTableFill,
  PiTableLight,
} from "react-icons/pi";
import { match } from "ts-pattern";

import DatabaseContent from "~/components/database/detail/database-content";
import SpDatabaseHeader from "~/components/database/detail/database-content/database-header/sp/SpDatabaseHeader";
import DatabaseResponseItemView from "~/components/database/detail/database-response-item-view";
import ItemModalContent from "~/components/database/detail/item-modal-content";
import { ModalContentKind } from "~/components/database/detail/lib";
import ResponseModalContent from "~/components/database/detail/response-modal-content";
import { Props } from "~/components/database/page/[id]/database-detail-page";

type DatabaseViewKind = "item" | "table";

const MobilePage = ({
  props,
  openResponseForm,
  openItemDetail,
  modalContent,
  closeModal,
  setSuppressModalClosingWarning,
}: Props) => {
  const theme = useTheme();
  const [databaseViewKind, setDatabaseViewKind] =
    useState<DatabaseViewKind>("item");
  const selectTableView = () => setDatabaseViewKind("table");
  const selectItemView = () => setDatabaseViewKind("item");

  return (
    <main css={rootStyle}>
      <SpDatabaseHeader
        openModal={() => openResponseForm(props.form.questions)}
        form={props.form}
      />
      <ResponseTableSection>
        <div>
          <IconButton onClick={selectItemView}>
            {databaseViewKind === "item" ? (
              <PiCardsFill size={28} />
            ) : (
              <PiCardsLight size={28} />
            )}
          </IconButton>

          <IconButton onClick={selectTableView}>
            {databaseViewKind === "table" ? (
              <PiTableFill size={28} />
            ) : (
              <PiTableLight size={28} />
            )}
          </IconButton>
        </div>
        {databaseViewKind === "table" ? (
          <DatabaseContent
            openItemDetail={openItemDetail}
            openResponseForm={openResponseForm}
            form={props.form}
          />
        ) : (
          <DatabaseResponseItemView props={props} />
        )}
      </ResponseTableSection>
      <Dialog
        open={modalContent.__kind !== ModalContentKind.HIDE}
        onClose={closeModal}
        fullWidth
        PaperProps={{
          sx: {
            width: "100%",
            m: 1,
          },
        }}
      >
        <DialogContent>
          <IconButton onClick={closeModal}>
            <CloseIcon sx={{ color: theme.palette.text.primary }} />
          </IconButton>
          {match(modalContent)
            .with({ __kind: ModalContentKind.RESPONSE_FORM }, (matched) => (
              <ResponseModalContent
                form={props.form}
                setModalClosable={setSuppressModalClosingWarning}
                closeModal={closeModal}
              />
            ))
            .with({ __kind: ModalContentKind.ITEM_DETAIL }, (matched) => (
              <ItemModalContent form={props.form} response={matched.response} />
            ))
            .with({ __kind: ModalContentKind.HIDE }, () => null)
            .exhaustive()}
        </DialogContent>
      </Dialog>
    </main>
  );
};

const ResponseTableSection = styled.section`
  overflow-x: scroll;
`;

const rootStyle = css``;

const DialogContent = styled.div``;

export default MobilePage;
